import React, { useState, useContext } from 'react';
import { Archive } from 'iconsax-react';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

export default function BlogCard({ image, title, author, readTime, popularityChip }) {
  const theme = useContext(ThemeContext);
  const [saved, setSaved] = useState(false);

  return (
    <div
      style={{
        backgroundColor: theme.cardBg,
        border: `1px solid ${theme.border}`,
        borderRadius: s(12),
        padding: s(12),
        display: 'flex',
        flexDirection: 'column',
        gap: s(12),
        width: s(260),
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      {/* Cover image */}
      <div style={{ position: 'relative', height: s(90), flexShrink: 0, borderRadius: s(10), overflow: 'hidden' }}>
        <img
          src={image}
          alt={title}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
        {popularityChip && (
          <div
            style={{
              position: 'absolute',
              top: s(12),
              right: s(12),
              backgroundColor: theme.bg200,
              borderRadius: s(8),
              padding: `${s(2)}px ${s(8)}px`,
            }}
          >
            <span className="font-satoshi" style={{ fontSize: 10, fontWeight: 500, color: theme.text100, lineHeight: 1 }}>
              {popularityChip}
            </span>
          </div>
        )}
      </div>

      {/* Text content */}
      <div style={{ display: 'flex', alignItems: 'stretch', gap: s(8) }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: s(2), minWidth: 0 }}>
          <p
            className="font-satoshi font-bold"
            style={{
              margin: 0,
              fontSize: s(18),
              lineHeight: `${s(24)}px`,
              color: theme.text100,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {title}
          </p>
          <div style={{ display: 'flex', gap: s(2), alignItems: 'center' }}>
            <span className="font-satoshi" style={{ fontSize: s(14), fontWeight: 500, color: theme.text400, whiteSpace: 'nowrap' }}>
              {author}
            </span>
            <span className="font-satoshi" style={{ fontSize: s(14), fontWeight: 500, color: theme.text400, whiteSpace: 'nowrap' }}>
              | {readTime}
            </span>
          </div>
        </div>
        <button
          onClick={() => setSaved(v => !v)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'flex-end', flexShrink: 0 }}
        >
          <Archive size={s(24)} variant={saved ? 'Bold' : 'Linear'} color={saved ? theme.btnPrimaryBg : theme.text400} />
        </button>
      </div>
    </div>
  );
}
